module.exports = __webpack_public_path__ + "static/media/notfound.770aa12e.png";